import Vue from 'vue';
import vueSlider from 'vue-slider-component/src/vue2-slider.vue';
import Multiselect from 'vue-multiselect';
import VueLazyBackgroundImage from 'vue-lazy-background-images/VueLazyBackgroundImage.vue';

Vue.component('lazy-background', VueLazyBackgroundImage)
const defsec = {
    x: false,
    y: false
}

const data = {
    price: undefined,
    xy_mechanism: undefined,
    x_mechanism: undefined,

    system: undefined,
    podocon: undefined,
    otliv: undefined,
    lamin: undefined,
    type_glazing: undefined,

    section_type: 'window',
    sections_count: 1,
    sections: [{
        x: false,
        y: false
    }],

    width: undefined,
    height: undefined,

    minw: undefined,
    minh: undefined,
    maxw: undefined,
    maxh: undefined,
    alt_width: 0,
    alt_height: 0,
}

const methods = {
    changeWidth() {
        this.width = this.alt_width
    },
    changeHeight() {
        this.height = this.alt_height
    },
    setSectionW1(event) {
        this.section_type = 'window'
        this.sections_count = 1
        this.sections = [{
            ...defsec
        }]
        this.setSizes(event.currentTarget)
    },
    setSectionW2(event) {
        this.section_type = 'window'
        this.sections_count = 2
        this.sections = [{
            ...defsec
        }, {
            ...defsec
        }]
        this.setSizes(event.currentTarget)
    },
    setSectionW3(event) {
        this.section_type = 'window'
        this.sections_count = 3
        this.sections = [{
            ...defsec
        }, {
            ...defsec
        }, {
            ...defsec
        }]
        this.setSizes(event.currentTarget)
    },
    setSectionD(event) {
        this.section_type = 'door'
        this.sections_count = 1
        this.sections = []
        this.setSizes(event.currentTarget)
    },
    setSizes(element) {
        this.minw = +element.getAttribute('data-minw')
        this.minh = +element.getAttribute('data-minh')
        this.maxw = +element.getAttribute('data-maxw')
        this.maxh = +element.getAttribute('data-maxh')
        this.width = +element.getAttribute('data-defw')
        this.height = +element.getAttribute('data-defh')
        this.refreshSliders()
    },
    changeSection(idx, x, y) {
        this.sections[idx].x = x
        this.sections[idx].y = y
    },
    refreshSliders() {
        if (this.$refs.hasOwnProperty('height_slider')) {
            setTimeout(this.$refs.height_slider.refresh, 100)
        }
        if (this.$refs.hasOwnProperty('width_slider')) {
            setTimeout(this.$refs.width_slider.refresh, 100)
        }
    },
    openModal(event) {
        event.preventDefault();
        let modal = $('#modal_calc')
        // get elements
        let prod_type = modal.find('.prod_type'),
            prod_main = modal.find('.prod_main'),
            prod_main_icon = modal.find('#prod_main_icon'),
            prod_size = modal.find('.prod_size'),
            prod_sections = modal.find('.prod_sections'),
            prod_system = modal.find('.prod_system'),
            prod_podocon = modal.find('.prod_podocon'),
            prod_otliv = modal.find('.prod_otliv'),
            prod_lamin = modal.find('.prod_lamin'),
            prod_glazing = modal.find('.prod_glazing'),
            text_area = modal.find('[name="textarea_hidden"]')

        // set values to table
        if (this.type === 'plastic' || this.type === 'aluminum') {
            if (this.section_type === 'window') {
                switch (this.sections.length) {
                    case 1:
                        prod_main.text('Одностворчатое окно')
                        prod_main_icon[0].className = 'icon-one'
                        break;
                    case 2:
                        prod_main.text('Двустворчатое окно')
                        prod_main_icon[0].className = 'icon-two'
                        break;
                    case 3:
                        prod_main.text('Трехстворчатое окно')
                        prod_main_icon[0].className = 'icon-three'
                        break;
                }
            } else {
                prod_main.text('Дверь')
                prod_main_icon[0].className = 'icon-door'
            }
        } else {
            prod_main.text('Перегородка')
            prod_main_icon[0].className = ''
        }
        prod_type.text((this.type === 'plastic') ? 'Пластиковые изделия' : (this.type === 'aluminum') ? 'Алюминивые изделия' : 'Перегородки')
        prod_size.text(`${this.width} mm X ${this.height} mm`)
        if (this.type === 'partitions') {
            prod_sections.hide()
        } else {
            prod_sections.show()
            prod_sections.html(this.sections.map((item) => {
                if (item.x && item.y) {
                    return "Поворотно откидная створка"
                } else if (item.x) {
                    return "Поворотная створка"
                } else {
                    return "Глухая створка"
                }
            }).join('<br/>'))
        }
        prod_system.text(this.system.label)
        if (this.type === 'partitions') {
            prod_podocon.hide()
        } else {
            prod_podocon.show()
            prod_podocon.text(this.podocon.label)
        }
        if (this.type === 'partitions') {
            prod_otliv.hide()
        } else {
            prod_otliv.show()
            prod_otliv.text(this.otliv.label)
        }
        if (this.type === 'partitions') {
            prod_lamin.hide()
        } else {
            prod_lamin.show()
            prod_lamin.text(this.lamin.label)
        }
        prod_glazing.text(this.type_glazing.label)
        // set values to textarea
        text_area.val(`
        Категория изделий: ${(this.type === 'plastic') ? 'Пластиковые изделия' : (this.type === 'aluminum') ? 'Алюминивые изделия' : 'Перегородки'}
        Размер изделия: ${this.width} X ${this.height}
        Тип изделия: ${this.section_type}
        Створки: ${this.sections.map((item) => {
            if (item.x && item.y) {
                return "Поворотно откидная створка"
            } else if (item.x) {
                return "Поворотная створка"
            } else {
                return "Глухая створка"
            }
        }).join(', ')}
        Система: ${this.system.label}
        Подоконник: ${this.podocon.label}
        Отлив: ${this.otliv.label}
        Ламинация: ${this.lamin.label}
        Тип остекления: ${this.type_glazing.label}
        `)
        // open modal
        modal.modal('show')
    }
}

const watch = {
    width() {
        this.alt_width = this.width
    },
    height() {
        this.alt_height = this.height
    }
}

const components = {
    vueSlider,
    Multiselect
}

const computed = {
    prod_price() {
        return ((this.height / 1000) * (this.width / 1000) * this.price *
        (this.system && +this.system.value || 1) * (this.lamin && +this.lamin.value || 1) * (this.type_glazing && +this.type_glazing.value || 1))
    },
    podocon_price() {
        if (this.podocon && this.podocon.hasOwnProperty('value')) {
            return ((this.width / 1000) * +this.podocon.value)
        } else {
            return 0
        }
    },
    otliv_price() {
        if (this.otliv && this.otliv.hasOwnProperty('value')) {
            return ((this.width / 1000) * +this.otliv.value)
        } else {
            return 0
        }
    },
    opensystem_price() {
        if (this.sections && this.sections.length) {
            return this.sections.reduce((prev, cur) => {
                if (cur.x && cur.y) {
                    return prev += this.xy_mechanism
                } else if (cur.x && !cur.y) {
                    return prev += this.x_mechanism
                } else {
                    return prev
                }
            }, 0)
        }
        return 0
    },
    sum() {
        return (this.prod_price + this.podocon_price + this.otliv_price + this.opensystem_price).toFixed(2)
    },
    height_mm() {
        return `${this.height} mm`
    },
    width_mm() {
        return `${this.width} mm`
    },
    widtherror() {
        return this.alt_width < this.minw || this.alt_width > this.maxw
    },
    heighterror() {
        return this.alt_height < this.minh || this.alt_height > this.maxh
    }
}

const mounted = function () {
    setTimeout(() => {
        if (this.$refs.hasOwnProperty('system_select')) {
            this.system = this.$refs.system_select.options[0]
        }
        if (this.$refs.hasOwnProperty('podocon_select')) {
            this.podocon = this.$refs.podocon_select.options[0]
        }
        if (this.$refs.hasOwnProperty('otliv_select')) {
            this.otliv = this.$refs.otliv_select.options[0]
        }
        if (this.$refs.hasOwnProperty('lamin_select')) {
            this.lamin = this.$refs.lamin_select.options[0]
        }
        if (this.$refs.hasOwnProperty('type_glazing_select')) {
            this.type_glazing = this.$refs.type_glazing_select.options[0]
        }
        this.price = +this.$el.getAttribute("data-baseprice")
        this.x_mechanism = +this.$el.getAttribute("data-xmechanismprice")
        this.xy_mechanism = +this.$el.getAttribute("data-xymechanismprice")
    }, 30)
}

let partitionsCalc = new Vue({
    el: '#partitions_calc',
    data: {
        ...data,
        type: 'partitions'
    },
    methods,
    watch,
    components,
    computed,
    mounted: function () {
        if (this.$refs.hasOwnProperty('partition_standardtab')) {
            this.setSizes(this.$refs.partition_standardtab)
        }
        mounted.apply(this, arguments)
    }
})
window.partitionsCalc = partitionsCalc

let plasticCalc = new Vue({
    el: '#plastic_calc',
    data: {
        ...data,
        type: 'plastic'
    },
    methods,
    watch,
    components,
    computed,
    mounted: function () {
        // set standard properties from first tab header
        if (this.$refs.hasOwnProperty('plastic_standardtab')) {
            this.setSizes(this.$refs.plastic_standardtab)
        }
        mounted.apply(this, arguments)
    }
})
window.plasticCalc = plasticCalc

let aluminumCalc = new Vue({
    el: '#aluminum_calc',
    data: {
        ...data,
        type: 'aluminum'
    },
    methods,
    watch,
    components,
    computed,
    mounted: function () {
        // set standard properties from first tab header
        if (this.$refs.hasOwnProperty('aluminum_standardtab')) {
            this.setSizes(this.$refs.aluminum_standardtab)
        }
        mounted.apply(this, arguments)
    }
})
window.aluminumCalc = aluminumCalc


// WEBPACK FOOTER //
// ./src/js/calculator/calculator.js